import React, { useState, useEffect } from 'react';
import axios  from 'axios';
import { TiTick } from 'react-icons/ti';
function Instruction() {
    const [thongtincum, setthongtincum] = useState(
          [{
            "TenThietBi": "Tạo lịch phát",
            "Id": 4260
          },
          {
            "TenThietBi": "Ghi âm phát trực tuyến",
            "Id": 4258
          },
          {
            "TenThietBi": "Đổi văn bản thành giọng nói",
            "Id": 4831
          }]
      );
    const [ThietBiId, setThietBiId] = useState(false);
    const handleClick = (itemId) => {
        setThietBiId(itemId);
      };
    return (
        <>
           <div className="max-w-2xl px-1 py-4   mx-auto rounded-lg shadow-xl ">
            <div className="grid mt-3 grid-cols-2 gap-4">
                {thongtincum.map((item) => (
                    <div
                        key={item.Id}
                        className={`bg-gray-200 p-4 rounded-lg cursor-pointer ${ThietBiId === item.Id ? 'bg-green-200' : ''
                            }`}
                        onClick={() => handleClick(item.Id)}
                    >
                        <div className="flex items-center justify-center mb-2">
                            {ThietBiId === item.Id && (
                                <TiTick className="w-10 h-10 text-green-500" />
                            )}
                        </div>
                        <p className="text-center">{item.TenThietBi}</p>
                    </div>
                ))}
            </div></div>
        </>

    );
}

export default Instruction;
